export default {
  markAllAsRead: 'Oznacz wszystkie jako przeczytane',
  showOnlyUnread: 'Pokaż tylko nieprzeczytane',
  seeAll: 'Zobacz wszystko',
};
